import { produtorService } from '../_services/';
import alerts from '../_components/alerts';

export const produtorAction = {
    getSelectProdutoresByPrefeitura
};

function getSelectProdutoresByPrefeitura(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'produtores/select/prefeitura';
        produtorService.post(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Value: '0', Text: ' SELECIONE ...' });
                dispatch(changeProdutoresList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

export function changeProdutoresList(produtor) {
    return {
        type: "FETECHED_ALL_PRODUTOR",
        produtor: produtor
    }
}
export function clear() {
    return {
        type: "PRODUTOR_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editProdutoresDetails(produtor) {
    return {
        type: "PRODUTOR_DETAIL",
        id: produtor.id,
        nome: produtor.nome,
        endereco: produtor.endereco,
        numero_matricula: produtor.numero_matricula,
        telefone: produtor.telefone,
        inscricao_municipal: produtor.inscricao_municipal,
        inscricao_estadual: produtor.inscricao_estadual,
        id_usuario: produtor.id_usuario
    }
}
export function updatedUserInfo() {
    return {
        type: "PRODUTOR_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "PRODUTOR_CREATED_SUCCESSFULLY"
    }
}
export function deleteProdutoresDetails() {
    return {
        type: "DELETED_PRODUTOR_DETAILS"
    }
}